/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI as any)
import App from './App.vue'

import '@/util/String'

// Vuesax Component Framework
import Vuesax from 'educatena-vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'educatena-vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// axios
import standard from '@/services/standard'
Vue.prototype.$http = standard.axios

// Theme Configurations
// import '../themeConfig'

// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)

import VueUtil from './util/VueUtils'
Vue.use(VueUtil)

// Globally Registered Components
import './globalComponents'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router/index'

// Vuex Store
import store from './store/store'

// Acl
import acl from './acl/directive'
Vue.use(acl)

// i18n
import i18n from './i18n/i18n'

// Vuesax Admin Filters
import './filters/filters'

// Font awesome icon
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFontAwesome } from '@fortawesome/free-brands-svg-icons'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

library.add(faFontAwesome)
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Vue Formulate
import Formulate from '@braid/vue-formulate'
import { pt } from '@braid/vue-formulate-i18n'
Vue.use(Formulate, {
  plugins: [ pt ]
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

Vue.use(require('vue-moment'))

// CKEditor
import CKEditor from '@ckeditor/ckeditor5-vue'
Vue.use(CKEditor)

import '@/libs/tour'
import '@/libs/vue-select'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

require('@core/scss/vue/libs/vue-select.scss')

// Socket
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'

if (eval(`${process.env.VUE_APP_SOCKET_CONNECT}`)) {
  const options = {}
  Vue.use(
    new VueSocketIO({
      debug: true,
      connection: SocketIO(`${process.env.VUE_APP_API_SOCKET_URL}:6001`, options),
      vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
      }
    })
  )
}

// Components
import Grid from './components/Grid.vue'
Vue.component('Grid', Grid)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, { name: 'custom', lodash })

import uuid from '@estudioliver/vue-uuid-v4'
Vue.use(uuid)

import underscore from 'vue-underscore'
Vue.use(underscore)

Vue.config.productionTip = false

Vue.config.silent = true

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
